import { __assign } from "tslib";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { useDrag, DragPreviewImage } from 'react-dnd';
import { Section } from '../../../../a11y/headings/tagWrappers';
import Heading from '../../../../a11y/headings/Heading';
import { VisuallyHidden } from '../../../../a11y';
import { MobileContext, SessionContext } from '../../../../Context';
import { useOverlayContext } from '../Overlay/OverlayContext/OverlayContext';
import { DraggableType } from '../../../../types/dnd';
import ErrorBoundary from '../../../../ErrorBoundary';
import DeviationDumbView from '../../../Dumbo';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { DeviationTypes } from '../../../../types/deviation';
import Overlay from '../Overlay';
import { BiDataHook } from '../../../../biLogger/constants';
import { getDeviationType } from '../../../_helpers';
import { getInfoToDisplayImageDeviation } from '../../../Dumbo/Image/_helpers';
import s from './Default.scss';
import overlayHelperStyles from '../OverlayHelpers.scss';
var Default = function (_a) {
    var className = _a.className, deviation = _a.deviation, height = _a.height, responsive = _a.responsive, style = _a.style, width = _a.width, extraActions = _a.extraActions;
    var showOverlayTitle = useOverlayContext(deviation).showTitle;
    var isMobile = useContext(MobileContext);
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var _b = useDrag({
        item: { type: DraggableType.DEVIATION, deviation: deviation },
        // !! to prevent any undefineds sneaking through and enabling this by mistake
        canDrag: !!(isLoggedIn && !isMobile),
    }), drag = _b[1], preview = _b[2];
    var type = getDeviationType(deviation);
    var linkAsWrapper = type === DeviationTypes.IMAGE;
    var customDragPreview = type === DeviationTypes.IMAGE;
    var dragPreviewInfo;
    if (customDragPreview) {
        dragPreviewInfo = getInfoToDisplayImageDeviation({
            deviation: deviation,
            height: height,
            width: width,
        });
    }
    return (React.createElement(React.Fragment, null,
        customDragPreview && dragPreviewInfo && (React.createElement(DragPreviewImage, { connect: preview, src: dragPreviewInfo.pickedImage.src })),
        React.createElement(Section, { className: classnames(s['root'], overlayHelperStyles['hoverable'], className), style: __assign({ width: width,
                height: height }, style), "data-hook": BiDataHook.DEVIATION_STD_THUMB, ref: drag },
            React.createElement(ErrorBoundary, null,
                !showOverlayTitle && (React.createElement(VisuallyHidden, null,
                    React.createElement(Heading, null, deviation.title))),
                linkAsWrapper ? (React.createElement(DeviationLink, { deviation: deviation, "aria-hidden": true, tabIndex: -1 },
                    React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, responsive: responsive }))) : (React.createElement(React.Fragment, null,
                    React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, responsive: responsive }),
                    React.createElement(DeviationLink, { deviation: deviation, className: s['link-overlay'], title: deviation.title, "aria-label": deviation.title },
                        React.createElement("span", null)))),
                React.createElement(Overlay, { deviation: deviation, width: width, height: height, className: s['overlay'], extraActions: extraActions })))));
};
Default.displayName = 'Default';
export default Default;
//# sourceMappingURL=Default.js.map